import Alpine from 'alpinejs'

export const initShowButton = () => {
    Alpine.data('showButton', (status) => ({
        status,
    }))
}
